import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { Routing } from "../../../../core/routing";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IProduct, IProductForm, productEditFormValidation } from "../../data/entities";
import { ProductForm } from "../components/form";
import { productRedux } from "../state/state";

export const ProductEditPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const id = match.params.id;
  const dispatch = useDispatch();
  const history = useHistory();

  const productDetailBranch = useSelector<IAppReduxState, IAsyncData<IProduct>>((state) => state.product.details);
  const editProductBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.product.edit);

  useEffect(() => {
    dispatch(productRedux.actions.getDetail(id));
  }, [dispatch, id]);

  const onSubmit = async (form: IProductForm): Promise<void> => {
    await dispatch(productRedux.actions.edit(id, form));
    history.push(Routing.generateDetailRoute(ROUTES.product, id));
  };

  return (
    <ProductForm
      initialData={productDetailBranch}
      onSubmit={onSubmit}
      branch={editProductBranch}
      validationSchema={productEditFormValidation}
      submitTitle="Edit"
    />
  );
};
